import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { FilterCompleteService } from '../../../filter-complete/filter-complete';
import { PhysicianFilter } from '../../../model/physician-Filter';
import { MedicalAppointmentProcedure } from '../../../model/medical-appointment-procedure';
import { FilterService } from '../../../services/filter.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { SpecialityFilter } from '../../../model/speciality-filter';
import { MedicalServiceService } from '../../../services/medical-service.service';
import { MedicalConsultationHistory } from '../../../model/medical-consultation-history';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { MedicalServiceCareComponent } from '../../medical-service/medical-service-care/medical-service-care.component';
import { PrescriptionDialogComponent, PrescriptionDialogResponse } from '../../dialogs/prescription-dialog/prescription-dialog.component';
import { PrescriptionService } from '../../../services/prescription.service';
import { DownloadLocalFileService } from '../../../services/download-local-file.service';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-consultation-history-control',
  templateUrl: './consultation-history-control.component.html',
  styleUrls: ['./consultation-history-control.component.css']
})
export class ConsultationHistoryControlComponent implements OnInit {

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '18rem',
    minHeight: '5rem',
    translate: 'no',
  };

  loading: boolean;
  consultationHistoryForm: FormGroup;
  displayColumnsPrincipal = ['PracticeRegionName', 'Quantity'];
  filterCompletePhysicians: FilterCompleteService<PhysicianFilter>;
  filterCompleteSpecialities: FilterCompleteService<SpecialityFilter>;
  medicalConsultationHistories: MedicalConsultationHistory[];
  physicianId?: number;
  specialityId?: number;
  dataSourcePrincipal: MatTableDataSource<MedicalAppointmentProcedure>;
  @Input() medicalAppointmentId?: number;
  @Input() patientId: number;
  patientFullName: string;
  protocol: string;
  prescriptionIds: number[] = [];
  patientAge: string;
  medicalConsultationObservation = '';
  medicalConsultationMedication = '';
  canCreatePrescriptions: boolean;
  loadingEditInfo: boolean;
  @Input() readOnly: boolean;
  @Output() loaded = new EventEmitter();
  @Output() medicalConsultationObservationChange = new EventEmitter();
  @Output() medicalConsultationMedicationChange = new EventEmitter();

  constructor(private formBuilder: FormBuilder,
              private notificationToastService: NotificationToastService,
              private medicalServiceService: MedicalServiceService,
              private dialog: MatDialog,
              private authService: AuthService,
              private prescriptionService: PrescriptionService,
              private downloadLocalFileService: DownloadLocalFileService,
              private filterService: FilterService) {


    this.canCreatePrescriptions = this.authService.canCreatePrescription();
    this.consultationHistoryForm = this.formBuilder.group({
      MedicalConsultationObservation: new FormControl({ value: '' }),
      MedicalConsultationMedication: new FormControl({ value: '', disabled: this.readOnly }),
      Speciality: new FormControl({ value: '' }),
      Physician: new FormControl({ value: '' })
    });
    this.filterCompletePhysicians = new FilterCompleteService<PhysicianFilter>([],
      this.consultationHistoryForm.controls.Physician);
    this.filterCompleteSpecialities = new FilterCompleteService<SpecialityFilter>([],
      this.consultationHistoryForm.controls.Speciality);
  }

  onSpecialityChange(): void {
    this.specialityId = null;
  }

  onPhysicianChange(): void {
    this.physicianId = null;
  }

  physicianSelected(physician: PhysicianFilter) {
    if (physician === null) {
      this.physicianId = null;
    } else {
      this.physicianId = physician.Id;
    }
  }

  specialitySelected(speciality: SpecialityFilter) {
    if (speciality === null) {
      this.specialityId = null;
    } else {
      this.specialityId = speciality.Id;
    }
  }

  get filteredPhysiciansOptions() { return this.filterCompletePhysicians ?
    this.filterCompletePhysicians.filteredOptions : []; }
  get filteredSpecialitiesOptions() { return this.filterCompleteSpecialities ?
    this.filterCompleteSpecialities.filteredOptions : []; }
  medicalConsultationHistoriesFiltered(): MedicalConsultationHistory[] {
    if (!this.medicalConsultationHistories) {
      return [];
    } else {
      let items: MedicalConsultationHistory[] = [];

      items = this.medicalAppointmentId? this.medicalConsultationHistories
                  .filter(m => m.MedicalAppointmentId !== this.medicalAppointmentId) 
                  : this.medicalConsultationHistories;

      if (this.specialityId) {
        items = items.filter(m => m.SpecialtyId === this.specialityId);
      }

      if (this.physicianId) {
        items = items.filter(m => m.PhysicianId === this.physicianId);
      }

      return items;
    }
  }

  private loadHistory(): void {
    this.loading = true;
    this.medicalServiceService.getMedicalConsultationHistory(this.patientId)
      .then((medicalConsultationHistories) => {
        this.medicalConsultationHistories = medicalConsultationHistories;
        this.loading = false;
    }).catch((err) => {
      this.notificationToastService
      .error(JSON.stringify(err.error), 'Historia clínica');
    });
  }

  private loadFilters(): void {
    this.filterService.getPhysiciansFilter().then((physicians) => {
      this.filterCompletePhysicians =
        new FilterCompleteService<PhysicianFilter>(physicians,
          this.consultationHistoryForm.controls.Physician);
    });
    this.filterService.getSpecialtiesFilterOnlyConsultation().then((specialities) => {
      this.filterCompleteSpecialities =
        new FilterCompleteService<SpecialityFilter>(specialities,
          this.consultationHistoryForm.controls.Speciality);
    });
  }

  ngOnInit(): void  {
    if (this.readOnly) {
      this.editorConfig.editable = false;
    }
      this.loadingEditInfo = true;

      if (this.medicalAppointmentId)
      this.medicalServiceService.getMedicalConsultationHistoryEditInfo(this.medicalAppointmentId)
        .then((medicalConsultationHistoryEditInfo) => {
          this.consultationHistoryForm.patchValue({
            MedicalConsultationObservation: [medicalConsultationHistoryEditInfo.Observation],
            MedicalConsultationMedication: [medicalConsultationHistoryEditInfo.Medication]
          });
          this.consultationHistoryForm.controls.MedicalConsultationObservation.valueChanges.subscribe((value) => {
            this.medicalConsultationObservationChange.emit(value);
          });
          this.consultationHistoryForm.controls.MedicalConsultationMedication.valueChanges.subscribe((value) => {
            this.medicalConsultationMedicationChange.emit(value);
          });
          this.medicalConsultationObservationChange.emit(medicalConsultationHistoryEditInfo.Observation);
          this.medicalConsultationMedicationChange.emit(medicalConsultationHistoryEditInfo.Medication);
          this.patientId = medicalConsultationHistoryEditInfo.PatientId;
          this.patientFullName = medicalConsultationHistoryEditInfo.PatientFullName;
          this.protocol = medicalConsultationHistoryEditInfo.Protocol;
          this.dataSourcePrincipal = new MatTableDataSource(medicalConsultationHistoryEditInfo.MedicalAppointmentProcedurePrincipals);
          this.patientAge = medicalConsultationHistoryEditInfo.PatientEge;
          this.prescriptionIds = medicalConsultationHistoryEditInfo.PrescriptionIds;
          this.loadingEditInfo = false;
          this.loaded.emit();
        }).catch((err) => {
          this.notificationToastService
          .error(JSON.stringify(err.error), 'Historia clínica');
          this.loadingEditInfo = false;
          this.loaded.emit();
      });

      this.loadFilters();
      this.loadHistory();
  }

  async downloadPrescriptions(item: MedicalConsultationHistory) {

      try {
        item.downloadingPrescription = true;
        const reports = await this.prescriptionService
          .getPrescriptionReportsBase64ByMedicalAppointmentId(item.MedicalAppointmentId);
          let id = 1;
          reports.forEach(report => {
            this.downloadLocalFileService
            .downLoadFile(report.ReportBase64, 'prescripción-' + id, 'pdf');
            id = id + 1; 
          })
      } catch ( err ) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Prescripción');
      } finally {
        item.downloadingPrescription = false;
      }

  }


  editPrescription(): void {

    const dialogRef = this.dialog.open(PrescriptionDialogComponent, {
      width: '50%',
      data:  {
        medicalAppointmentId: this.medicalAppointmentId,
        protocol: this.protocol,
        patient: this.patientFullName,
        patientAge: this.patientAge,
        prescriptionIds: this.prescriptionIds
      }
    });

    dialogRef.afterClosed().subscribe(async (response: PrescriptionDialogResponse) => {
      if (response) {
       if (!response.delete) {
         this.prescriptionIds.push(response.id);
       } else {
         const index = this.prescriptionIds.findIndex(p => p === response.id);
         this.prescriptionIds.splice(index, 1);
       }
      }
    });


  }

}
